import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.706 2.914a1.014 1.014 0 0 0 1.512.627c3.414-2.08 7.322 1.827 5.243 5.241a1.014 1.014 0 0 0 .625 1.512c3.885.942 3.885 6.468 0 7.412a1.014 1.014 0 0 0-.627 1.512c2.08 3.414-1.827 7.322-5.241 5.243a1.014 1.014 0 0 0-1.512.625c-.942 3.885-6.468 3.885-7.412 0a1.014 1.014 0 0 0-1.512-.627c-3.414 2.08-7.321-1.827-5.243-5.241a1.014 1.014 0 0 0-.625-1.512c-3.885-.942-3.885-6.468 0-7.412a1.014 1.014 0 0 0 .627-1.512C1.46 5.368 5.368 1.461 8.782 3.54a1.01 1.01 0 0 0 1.512-.625c.942-3.885 6.468-3.885 7.412 0M14 9.8a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4"
    }, null, -1)
  ])))
}
export default { render: render }